import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../utils/api";

export default function RegisterPage() {
  const [form, setForm] = useState({ username: "", full_name: "", password: "", confirm: "", phone: "", email: "", zone: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function setF(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.username || !form.full_name || !form.password) {
      setError("Veuillez remplir tous les champs obligatoires");
      return;
    }
    if (form.password !== form.confirm) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    if (form.password.length < 6) {
      setError("Mot de passe trop court (min 6 caracteres)");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.register(form);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (success) {
    return (
      <div style={{ minHeight:"100vh", background:"var(--navy)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
        <div style={{ background:"white", borderRadius:16, padding:"40px 36px", width:"100%", maxWidth:420, textAlign:"center" }}>
          <div style={{ fontSize:48, marginBottom:16 }}>✅</div>
          <h2 style={{ color:"var(--navy)", marginBottom:12 }}>Inscription envoyee !</h2>
          <p style={{ color:"var(--muted)", marginBottom:24, fontSize:14 }}>
            Votre demande a ete transmise. Un administrateur va valider votre compte.
            Vous recevrez une confirmation avant de pouvoir vous connecter.
          </p>
          <Link to="/login" style={{ color:"var(--navy)", fontWeight:600, fontSize:14 }}>
            Retour a la connexion
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", background:"var(--navy)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"white", borderRadius:16, padding:"36px 32px", width:"100%", maxWidth:480, boxShadow:"0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ width:50, height:50, background:"var(--navy)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 10px", fontSize:24, fontWeight:800, color:"var(--accent)" }}>L</div>
          <div style={{ fontWeight:800, fontSize:18, color:"var(--navy)" }}>LUXOLOR</div>
          <div style={{ fontSize:13, color:"var(--muted)", marginTop:4 }}>Inscription Inspecteur</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:".08em", marginBottom:12 }}>
            Informations personnelles
          </div>
          <div className="form-grid" style={{ marginBottom:16 }}>
            <div className="form-group full">
              <label>Nom complet *</label>
              <input value={form.full_name} onChange={e => setF("full_name", e.target.value)} placeholder="Prenom Nom" required />
            </div>
            <div className="form-group">
              <label>Telephone</label>
              <input value={form.phone} onChange={e => setF("phone", e.target.value)} placeholder="+216 XX XXX XXX" type="tel" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input value={form.email} onChange={e => setF("email", e.target.value)} placeholder="email@exemple.com" type="email" />
            </div>
            <div className="form-group full">
              <label>Zone d'intervention</label>
              <input value={form.zone} onChange={e => setF("zone", e.target.value)} placeholder="ex: Grand Tunis, Sahel, Sud..." />
            </div>
          </div>

          <div style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:".08em", marginBottom:12, marginTop:8 }}>
            Compte de connexion
          </div>
          <div className="form-grid">
            <div className="form-group full">
              <label>Identifiant *</label>
              <input value={form.username} onChange={e => setF("username", e.target.value)} placeholder="ex: walid.inspecteur" required />
            </div>
            <div className="form-group">
              <label>Mot de passe *</label>
              <input type="password" value={form.password} onChange={e => setF("password", e.target.value)} placeholder="Min 6 caracteres" required minLength={6} />
            </div>
            <div className="form-group">
              <label>Confirmer *</label>
              <input type="password" value={form.confirm} onChange={e => setF("confirm", e.target.value)} placeholder="Repeter le mot de passe" required />
            </div>
          </div>

          {error && (
            <div style={{ background:"#fee2e2", color:"var(--red)", borderRadius:8, padding:"10px 14px", fontSize:13, marginTop:16 }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary w-full" style={{ width:"100%", justifyContent:"center", padding:"12px", fontSize:15, marginTop:20 }} disabled={loading}>
            {loading ? "Envoi en cours..." : "Envoyer ma demande d'inscription"}
          </button>
        </form>

        <div style={{ textAlign:"center", marginTop:20, fontSize:13 }}>
          <span style={{ color:"var(--muted)" }}>Deja inscrit ? </span>
          <Link to="/login" style={{ color:"var(--navy)", fontWeight:600 }}>Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
